import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { ContainerSize } from '@freelancer/ui/container';
import { HeadingColor, HeadingType } from '@freelancer/ui/heading';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { LinkColor } from '@freelancer/ui/link';
import { LogoSize } from '@freelancer/ui/logo';
import { Margin } from '@freelancer/ui/margin';
import { BackgroundColor } from '@freelancer/ui/page-layout';
import { FontColor, TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-header',
  template: `
    <fl-bit class="PagePostProject-header">
      <fl-container [size]="ContainerSize.TABLET" [mobilePadding]="true">
        <fl-bit [ngClass]="{ 'PagePostProject-container': isReposted }">
          <fl-bit class="PagePostProject-contentContainer">
            <fl-bit
              [flMarginBottom]="Margin.SMALL"
              [flMarginBottomDesktop]="Margin.XLARGE"
            >
            </fl-bit>
            <fl-bit
              [flMarginBottom]="Margin.SMALL"
              [flMarginBottomDesktop]="Margin.XLARGE"
            >
              <fl-link flTrackingLabel="PostJobPageLogo" [link]="'/'">
                <fl-logo
                  [backgroundColor]="BackgroundColor.DARK"
                  [size]="logoSize"
                ></fl-logo>
              </fl-link>
              <ng-container *ngIf="phone && email">
                <fl-text
                  [color]="FontColor.LIGHT"
                  [size]="TextSize.SMALL"
                  [sizeDesktop]="TextSize.MID"
                >
                  <fl-link
                    flTrackingLabel="PostJobPagePhoneNumber"
                    [color]="LinkColor.LIGHT"
                    [link]="'tel:' + (phone || '')"
                    [iconColor]="IconColor.LIGHT"
                    [iconName]="'ui-phone-alt'"
                    [size]="TextSize.INHERIT"
                  >
                    {{ phone }}
                  </fl-link>
                </fl-text>
                <fl-text
                  [color]="FontColor.LIGHT"
                  [size]="TextSize.SMALL"
                  [sizeDesktop]="TextSize.MID"
                >
                  <fl-icon
                    [color]="IconColor.LIGHT"
                    [name]="'ui-mail'"
                    [size]="IconSize.SMALL"
                  ></fl-icon>
                  {{ email }}
                </fl-text>
              </ng-container>
            </fl-bit>
            <fl-heading
              i18n="Post Job Page Form heading"
              [color]="HeadingColor.LIGHT"
              [flMarginBottom]="Margin.SMALL"
              [flMarginBottomDesktop]="Margin.MID"
              [headingType]="HeadingType.H1"
              [size]="TextSize.LARGE"
              [sizeDesktop]="TextSize.XLARGE"
            >
              {{ headerText }}
            </fl-heading>
            <fl-text
              class="PagePostProject-header-desc"
              i18n="Post Job Page Form heading description"
              [flHideMobileSmall]="true"
              [color]="FontColor.LIGHT"
              [size]="subHeaderTextSize"
            >
              {{ subHeaderText }}
            </fl-text>
            <fl-text
              class="PagePostProject-header-desc"
              [color]="FontColor.LIGHT"
              [flMarginBottom]="Margin.SMALL"
              [flShowMobileSmall]="true"
            >
              {{ mobileSubHeaderText }}
            </fl-text>
          </fl-bit>
          <fl-button
            *ngIf="isReposted"
            class="PagePostProject-header-clearFormButton"
            i18n="Button for clearing form"
            flTrackingLabel="ClearPostProjectForm"
            [color]="ButtonColor.TRANSPARENT_LIGHT"
            [flHideMobile]="true"
            [size]="ButtonSize.SMALL"
            (click)="clearForm.emit()"
          >
            Clear Form
          </fl-button>
        </fl-bit>
      </fl-container>
    </fl-bit>
  `,
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  BackgroundColor = BackgroundColor;
  ButtonColor = ButtonColor;
  ButtonSize = ButtonSize;
  ContainerSize = ContainerSize;
  FontColor = FontColor;
  HeadingColor = HeadingColor;
  HeadingType = HeadingType;
  IconColor = IconColor;
  IconSize = IconSize;
  LinkColor = LinkColor;
  LogoSize = LogoSize;
  Margin = Margin;
  TextSize = TextSize;

  @Input() email?: string;
  @Input() headerText: string;
  @Input() isReposted = false;
  @Input() logoSize = LogoSize.MID;
  @Input() mobileSubHeaderText: string;
  @Input() phone?: string;
  @Input() subHeaderText: string;
  @Input() subHeaderTextSize? = TextSize.XSMALL;

  @Output() clearForm = new EventEmitter<void>();
}
